import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trucks: { loading: false, data: [], error: null },
  drivers: { loading: false, data: [], error: null },
  routes: { loading: false, data: [], error: null },
  queues: { loading: false, data: null, error: null },
  assignmentHistory: { loading: false, data: [], error: null },
  requestedQueue: { loading: false, data: [], error: null },
  pendingSchedulingQueue: { loading: false, data: [], error: null },
  todayRoutes: { loading: false, data: [], error: null },
  exceptionQueue: { loading: false, data: [], error: null },
  discrepancyQueue: { loading: false, data: [], error: null },
  closeoutBacklog: { loading: false, data: [], error: null },
  resetReadyQueue: { loading: false, data: [], error: null },
};

const dispatchSlice = createSlice({
  name: "afmsDispatch",
  initialState,
  reducers: {
    // Trucks
    trucksStart: (state) => { state.trucks.loading = true; state.trucks.error = null; },
    trucksSuccess: (state, action) => { state.trucks.loading = false; state.trucks.data = action.payload; },
    trucksFailure: (state, action) => { state.trucks.loading = false; state.trucks.error = action.payload; },

    // Drivers
    driversStart: (state) => { state.drivers.loading = true; state.drivers.error = null; },
    driversSuccess: (state, action) => { state.drivers.loading = false; state.drivers.data = action.payload; },
    driversFailure: (state, action) => { state.drivers.loading = false; state.drivers.error = action.payload; },

    // Routes
    routesStart: (state) => { state.routes.loading = true; state.routes.error = null; },
    routesSuccess: (state, action) => { state.routes.loading = false; state.routes.data = action.payload; },
    routesFailure: (state, action) => { state.routes.loading = false; state.routes.error = action.payload; },

    // Queues
    queuesStart: (state) => { state.queues.loading = true; state.queues.error = null; },
    queuesSuccess: (state, action) => { state.queues.loading = false; state.queues.data = action.payload; },
    queuesFailure: (state, action) => { state.queues.loading = false; state.queues.error = action.payload; },

    // Assignment History
    assignmentHistoryStart: (state) => { state.assignmentHistory.loading = true; state.assignmentHistory.error = null; },
    assignmentHistorySuccess: (state, action) => { state.assignmentHistory.loading = false; state.assignmentHistory.data = action.payload; },
    assignmentHistoryFailure: (state, action) => { state.assignmentHistory.loading = false; state.assignmentHistory.error = action.payload; },

    // Workbench Queues
    requestedQueueStart: (state) => { state.requestedQueue.loading = true; state.requestedQueue.error = null; },
    requestedQueueSuccess: (state, action) => { state.requestedQueue.loading = false; state.requestedQueue.data = action.payload; },
    requestedQueueFailure: (state, action) => { state.requestedQueue.loading = false; state.requestedQueue.error = action.payload; },

    pendingSchedulingQueueStart: (state) => { state.pendingSchedulingQueue.loading = true; state.pendingSchedulingQueue.error = null; },
    pendingSchedulingQueueSuccess: (state, action) => { state.pendingSchedulingQueue.loading = false; state.pendingSchedulingQueue.data = action.payload; },
    pendingSchedulingQueueFailure: (state, action) => { state.pendingSchedulingQueue.loading = false; state.pendingSchedulingQueue.error = action.payload; },

    todayRoutesStart: (state) => { state.todayRoutes.loading = true; state.todayRoutes.error = null; },
    todayRoutesSuccess: (state, action) => { state.todayRoutes.loading = false; state.todayRoutes.data = action.payload; },
    todayRoutesFailure: (state, action) => { state.todayRoutes.loading = false; state.todayRoutes.error = action.payload; },

    exceptionQueueStart: (state) => { state.exceptionQueue.loading = true; state.exceptionQueue.error = null; },
    exceptionQueueSuccess: (state, action) => { state.exceptionQueue.loading = false; state.exceptionQueue.data = action.payload; },
    exceptionQueueFailure: (state, action) => { state.exceptionQueue.loading = false; state.exceptionQueue.error = action.payload; },

    discrepancyQueueStart: (state) => { state.discrepancyQueue.loading = true; state.discrepancyQueue.error = null; },
    discrepancyQueueSuccess: (state, action) => { state.discrepancyQueue.loading = false; state.discrepancyQueue.data = action.payload; },
    discrepancyQueueFailure: (state, action) => { state.discrepancyQueue.loading = false; state.discrepancyQueue.error = action.payload; },

    closeoutBacklogStart: (state) => { state.closeoutBacklog.loading = true; state.closeoutBacklog.error = null; },
    closeoutBacklogSuccess: (state, action) => { state.closeoutBacklog.loading = false; state.closeoutBacklog.data = action.payload; },
    closeoutBacklogFailure: (state, action) => { state.closeoutBacklog.loading = false; state.closeoutBacklog.error = action.payload; },

    resetReadyQueueStart: (state) => { state.resetReadyQueue.loading = true; state.resetReadyQueue.error = null; },
    resetReadyQueueSuccess: (state, action) => { state.resetReadyQueue.loading = false; state.resetReadyQueue.data = action.payload; },
    resetReadyQueueFailure: (state, action) => { state.resetReadyQueue.loading = false; state.resetReadyQueue.error = action.payload; },
  },
});

export const {
  trucksStart, trucksSuccess, trucksFailure,
  driversStart, driversSuccess, driversFailure,
  routesStart, routesSuccess, routesFailure,
  queuesStart, queuesSuccess, queuesFailure,
  assignmentHistoryStart, assignmentHistorySuccess, assignmentHistoryFailure,
  requestedQueueStart, requestedQueueSuccess, requestedQueueFailure,
  pendingSchedulingQueueStart, pendingSchedulingQueueSuccess, pendingSchedulingQueueFailure,
  todayRoutesStart, todayRoutesSuccess, todayRoutesFailure,
  exceptionQueueStart, exceptionQueueSuccess, exceptionQueueFailure,
  discrepancyQueueStart, discrepancyQueueSuccess, discrepancyQueueFailure,
  closeoutBacklogStart, closeoutBacklogSuccess, closeoutBacklogFailure,
  resetReadyQueueStart, resetReadyQueueSuccess, resetReadyQueueFailure,
} = dispatchSlice.actions;

export default dispatchSlice.reducer;
